//热门推荐
<template>
  <div class="hot1">
    <div class="title">
      热门推荐
    </div>
    <div v-for="(item,index) in list" :key="index" class="box1">
      <span class="sanjiao" /><a class="titlename" :href="'/Detail?contentId='+item.CONTENT_ID" target="_blank">{{ item.CONTENT_TITLE }}</a>
      <div class="borderDIV" />
    </div>
  </div>
</template>
<script>
export default {
  props: ['list'],
  methods: {
    goDetail: function(contentId) {
      const { href } = this.$router.resolve({
        path: '/Detail',
        name: 'dt',
        query: {
          contentId
        }
      })
      window.open(href, '_blank')
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .hot1{
        background-color: #fff;
        padding-bottom: 20px;
        overflow: hidden;
        padding-top: 10px;
        .title{

            height: 20px;
            line-height: 20px;
            border-left: 2px solid #ed4040;
            padding-left: 10px;
            font-size: 16px;
            margin-left: 20px;
        }
        .box1{
            width: 270px;
            height: 35px;
            margin-top: 8px;
            margin-left: 20px;
            line-height: 19px;
            .borderDIV{
                width: 100%;
                height: 1px;
                background-image: linear-gradient(to right, #f1f1f1 0%, #f1f1f1 50%, transparent 50%);
                background-size: 12px 1px;
                background-repeat: repeat-x;
                margin-top: 10px;
            }
            .sanjiao{
                width: 0;
                height: 0;
                border-left: 5px solid #b3b3b3;
                border-top: 5px solid transparent;
                border-bottom: 5px solid transparent;
                display: inline-block;
                vertical-align: middle;
                margin-top:2px;
            }
            .titlename{
                width: 235px;
                font-size: 14px;
                color: #333333;
                cursor: pointer;
                margin-left: 10px;
                display: inline-block;
                overflow: hidden;
               text-overflow: ellipsis;
                white-space: nowrap;
                vertical-align: middle;
              &:hover{
                color: #ed4040;
              }
            }
            }
    }
</style>
